import {
	CheckoutState,
	SET_SCREENSHOT_SPINNER,
	SCREENSHOT_PENDING,
	SCREENSHOT_SUCCESS,
	FETCH_VPC_PENDING,
	FETCH_VPC_SUCCESS,
	FETCH_VPC_FAILURE,
	SET_NO_SUMMARY_PAGE_BACK_BUTTON,
	SET_VISIBLE_MODAL,
	SET_SAVED_VPC_CONFIGURATION,
	SET_DESIGN_SOURCE,
	SET_UPPTACKA_SAVE_FAIL,
	SET_TWO_SEPARATE_SOFAS,
	SET_SHOW_SUMMARY,
	SET_STOCKED_IKEA_PLUS,
} from './types';
import { Actions } from '..';

const initialState: CheckoutState = {
	vpcCode: null,
	fetchVpcPending: false,
	showScreenshotSpinner: false,
	noSummaryPageBackButton: false,
	screenshotPending: null,
	visibleModal: null,
	savedVpcConfiguration: null,
	designSource: null,
	upptackaSaveFail: false,
	twoSeparateSofas: false,
	showSummary: false,
	stockedIkeaPlus: false,
};

export function checkoutReducer(state = initialState, action: Actions): CheckoutState {
	switch (action.type) {
		case SET_SCREENSHOT_SPINNER:
			return { ...state, showScreenshotSpinner: action.value };
		case SCREENSHOT_PENDING:
			return { ...state, screenshotPending: true, showScreenshotSpinner: true };
		case SCREENSHOT_SUCCESS:
			return {
				...state,
				screenshotPending: false,
				screenshot: action.data,
				showScreenshotSpinner: false,
			};
		case FETCH_VPC_PENDING:
			return { ...state, fetchVpcPending: true };
		case FETCH_VPC_SUCCESS: {
			const { vpcCode } = action;
			const vpcErrorMessage = state.vpcErrorMessage && null;
			return { ...state, vpcCode, fetchVpcPending: false, vpcErrorMessage };
		}
		case FETCH_VPC_FAILURE:
			return { ...state, fetchVpcPending: false, vpcErrorMessage: action.message, vpcCode: null };
		case SET_NO_SUMMARY_PAGE_BACK_BUTTON:
			return { ...state, noSummaryPageBackButton: action.value };
		case SET_VISIBLE_MODAL:
			return { ...state, visibleModal: action.value };
		case SET_SAVED_VPC_CONFIGURATION:
			return { ...state, savedVpcConfiguration: action.value };
		case SET_DESIGN_SOURCE:
			return { ...state, designSource: action.value };
		case SET_UPPTACKA_SAVE_FAIL:
			return { ...state, upptackaSaveFail: action.value };
		case SET_TWO_SEPARATE_SOFAS:
			return { ...state, twoSeparateSofas: action.value };
		case SET_SHOW_SUMMARY:
			return { ...state, showSummary: action.value };
		case SET_STOCKED_IKEA_PLUS:
			return { ...state, stockedIkeaPlus: action.value };
		default:
			return state;
	}
}
